<template>
  <div class="py-6 px-8">
    <h-header />
    <v-tabs v-model="tab" color="realEstate">
      <v-tab>
        <div class="mr-1">
          {{ $t('hausefulInvoices.HOST') }}
        </div>
        <InformationTooltip :message="$t('hausefulInvoices.messages.hostInvoices')" />
      </v-tab>
      <v-tab>
        <div class="mr-1">
          {{ $t('hausefulInvoices.HAUSEFUL') }}
        </div>
        <InformationTooltip :message="$t('hausefulInvoices.messages.hausefulInvoices')" />
      </v-tab>
    </v-tabs>
    <v-card outlined>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <CustomerHostReceivedInvoices />
        </v-tab-item>
        <v-tab-item>
          <CustomerHausefulReceivedInvoices />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import CustomerHostReceivedInvoices from './fragments/CustomerHostReceivedInvoices.vue';
import CustomerHausefulReceivedInvoices from './fragments/CustomerHausefulReceivedInvoices.vue';
import InformationTooltip from '../../../components/app/InformationTooltip.vue';

export default {
  name: 'CustomerInvoices',

  components: {
    CustomerHostReceivedInvoices,
    CustomerHausefulReceivedInvoices,
    InformationTooltip
  },

  data() {
    return {
      tab: 0,
    }
  },
}
</script>
